import { createContext, useContext, useState } from "react"
import { type PearlContext as PearlContextType, PearlProviderProps } from "./types"

export const PearlContext = createContext<PearlContextType | null>(null)

export function usePearlContext<T>() {
  const context = useContext(PearlContext)

  if (!context) throw new Error("usePearlContext must be called within PearlProvider")

  return context as T
}

export function PearlProvider({ children, value = {} }: PearlProviderProps) {
  const [focusedField, setFocusedField] = useState<string | undefined>(undefined)

  return (
    <PearlContext.Provider value={{ focusedField, setFocusedField, ...value }}>
      {children}
    </PearlContext.Provider>
  )
}
